import Vue from 'vue';
import {
  ConfigProvider,
  TreeSelect,
  Collapse,
  Cascader,
  Row,
  Col,
  Descriptions,
  Button,
  Drawer,
  Form,
  Icon,
  Input,
  Layout,
  List,
  Menu,
  message,
  Modal,
  Pagination,
  Popover,
  Spin,
  Select,
  Switch,
  Table,
  Tag,
  Upload,
  Progress,
  Checkbox,
  FormModel,
  Tabs,
  AutoComplete,
  Tooltip,
  Badge,
  Space,
  InputNumber,
} from 'ant-design-vue';
import { VueConstructor } from 'vue/types/umd';

function install(vue: VueConstructor) {
  vue.use(Button);
  vue.use(Drawer);
  vue.use(Form);
  vue.use(Icon);
  vue.use(Input);
  vue.use(Layout);
  vue.use(List);
  vue.use(Menu);
  vue.use(Modal);
  vue.use(Pagination);
  vue.use(Popover);
  vue.use(Spin);
  vue.use(Select);
  vue.use(Switch);
  vue.use(Table);
  vue.use(Tag);
  vue.use(Upload);
  vue.use(Descriptions);
  vue.use(Row);
  vue.use(Col);
  vue.use(Cascader);
  vue.use(Collapse);
  vue.use(TreeSelect);
  vue.use(Progress);
  vue.use(ConfigProvider);
  vue.use(Checkbox);
  vue.use(FormModel);
  vue.use(Tabs);
  vue.use(AutoComplete);
  vue.use(Tooltip);
  vue.use(Badge);
  vue.use(Space);
  vue.use(InputNumber);
}

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
export default install;
